import { defineComponent as _defineComponent } from 'vue'
import { ref, useRoute, watch } from '@nuxtjs/composition-api';
import FooterMainMenuItem from '@/domains/menus/components/FooterMainMenuItem.vue';

interface Props {
  menu?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterMainMenu',
  props: {
    menu: { default: () => [] }
  },
  setup(__props: any) {



const route = useRoute();
const activeItem = ref(null);

watch(
  route,
  () => {
    activeItem.value = null;
  },
  { immediate: true },
);

return { __sfc: true,route, activeItem, FooterMainMenuItem }
}

})